<template>
  <div class="search-associate">
    <ul class="search-associate-list">
      <li
        class="search-associate-item"
        v-for="item in myAssociateList"
        :key="item"
      >
        <router-link
          :data-keyword="item"
          :to="getSearchUrl(item)"
          @click="handleClick(item)"
          >
            <span v-html="getHighlight(item)"></span>
          </router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { getSearchUrl, highlight } from '@/utils';

export default {
  props: {
    keyword: {
      type: String,
      default: ''
    },
    associateList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    myAssociateList() {
      return this.associateList.map(item => item.trim());
    }
  },
  methods: {
    getSearchUrl,
    handleClick(keyword) {
      // this.$firebase.academySearchpopupClick({
      //   content: 'suggestions',
      //   searchkey: keyword,
      // });
      // this.$emit('set-focus');
    },
    getHighlight(str) {
      return highlight(this.keyword, str);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.search-associate {
  @include dropdown-style();

  &-item {
    list-style: none;
    text-align: left;
    line-height: 16px;
    box-sizing: border-box;

    &:hover {
      background: var(--current-bg-hover-color);
    }

    > a {
      padding: 10px;
      display: block;
      color: var(--current-default-color);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page-navbar/search/associate.vue